/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { useOnMount } from '@utils/reactExt'
import { Button } from '@styles/button.style'
import EventPage01 from '@assets/images/event-page/evpg.jpg'
import EventPageBtn from '@assets/images/event-page/evpg-btn.png'
// eslint-disable-next-line import/extensions
import EventPageGif from '@assets/images/event-page/evpg-visualization.gif'
import { EventPageWrap } from '@views/EventPage/index.style'
import { makeAdventurerHomePageUrl, makeAdventurerUrl, getHashParameter } from '@utils/utils'
import { HASH_PARAMETER } from '@constants/index'
import { isMobile } from 'react-device-detect'

const EVENT_PAGE_01 = 'm-eventPage01'.toLowerCase()
const EVENT_PAGE_02 = 'm-eventPage02'.toLowerCase()

const EventPage: React.FC = props => {

  useOnMount(() => {
    // 이벤트 페이지에서 나간 후 뒤로가기로 재진입 할 경우
    // hash 변경만 발생하므로 임게임 레이아웃 등이 반응하지 않기 때문에 재로드 한다.
    const body = document.querySelector('.event-page-body')
    if (!body) {
      window.location.reload()
    } else {
      const href = window.location.href
      const hashPosition = href.indexOf('#')
      const parameterPosition = href.indexOf('?')
      if (hashPosition > -1 && parameterPosition > -1 && hashPosition > parameterPosition) {
        const url = href.substr(0, parameterPosition - 1) + href.substr(hashPosition)
        window.location.href = url
      }
    }
  })

  const onClickLinkButton = () => {
    let targetUrl = ''

    const hash = window.location.hash.toLowerCase()
    if (hash.indexOf(EVENT_PAGE_01) > -1) {
      targetUrl = makeAdventurerUrl()
    } else if (hash.indexOf(EVENT_PAGE_02) > -1) {
      targetUrl = makeAdventurerHomePageUrl()
    }

    const marketingIdHashParameter = getHashParameter(HASH_PARAMETER.MARKETING_ID.KEY)
    targetUrl += `?${marketingIdHashParameter}`

    window.location.href = targetUrl

    // hash 변경만 발생할 경우임게임 레이아웃 등이 반응하지 않기 때문에 재로드 한다.
    if (targetUrl.indexOf(process.env.HOMEPAGE_PC) < 0) {
      window.location.reload()
    }
  }

  return (
    <EventPageWrap>
      <img src={EventPage01} alt="10만 G머니 (1만원 상당) 무료로 받고! 실시간으로 생생하게 스포츠 예측을 즐겨보세요!" className="event-page-img"/>
      <img src={EventPageGif} alt="비주얼라이제이션 gif" className={isMobile ? 'event-page-gif' : 'event-page-gif pc'}/>
      <Button className={isMobile ? 'event-page-btn' : 'event-page-btn pc'} onClick={onClickLinkButton}>
        <img src={EventPageBtn} alt="지금 가입하시면 100,000 G머니(1만원 상당) 무료 지급! 바로가기"/>
      </Button>
    </EventPageWrap>
  )
}
export default observer(EventPage)
